import { render, staticRenderFns } from "./VeBar.vue?vue&type=template&id=4bdbae45&scoped=true&"
import script from "./VeBar.vue?vue&type=script&lang=js&"
export * from "./VeBar.vue?vue&type=script&lang=js&"
import style0 from "./VeBar.vue?vue&type=style&index=0&id=4bdbae45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdbae45",
  null
  
)

export default component.exports